import { RunningTimerSession, RunningTimerView } from '../utils/resolveRunningTimerView';

import { fetchSubTicketDetail } from './effects';
import { detailKey, nextGeneration } from './requestGeneration';

// Issues the one detail read the resolved view asked for, and nothing else.
//
// The decision itself lives in `resolveRunningTimerView`, which is a pure function over the
// active session, the list read state and the details already known. Keeping the issuing here
// means the page never re-derives that decision inline, and the whole path — settled list, no
// read; unsettled list, no read; absent from a settled list, exactly one read — is drivable
// end to end without mounting anything.
export const issueRunningTimerDetail = (view: RunningTimerView, session: RunningTimerSession | null): boolean => {
    if (!session || !view.fetchDetailId) {
        return false;
    }

    // Keyed by the phase's own identity: the expanded panel and this label are legitimately in
    // flight at the same time, and neither may settle the other
    fetchSubTicketDetail({
        taskId: session.task_id,
        id: view.fetchDetailId,
        generation: nextGeneration(detailKey(session.task_id, view.fetchDetailId)),
    }).catch((e) => {
        // A missing label degrades to "another sub-ticket"; the link still resolves
        console.error(e);
    });

    return true;
};
